import { ErrorMessage } from 'formik'
import Select from 'react-select'
import TextError from './TextError'
import { customStyles } from './customStyles'

const ReactSelect = ({
  id,
  name,
  value = null,
  options,
  onChange,
  menuPortalTarget,
  isRequired = true,
  errors,
  touched,
  ...props
}) => {
  return (
    <>
      <Select
        inputId={id}
        name={name}
        menuPortalTarget={menuPortalTarget ? menuPortalTarget : document.body}
        menuPosition={'fixed'}
        value={value}
        styles={customStyles}
        options={options}
        onChange={onChange}
        {...props}
      />

      {errors && touched && !value?.value && isRequired && !!name ? (
        <div className='text-danger'>
          {typeof errors === 'object' ? errors[name] : errors}
        </div>
      ) : (
        name && <ErrorMessage name={name} component={TextError} />
      )}
    </>
  )
}

export default ReactSelect
